import { type FC } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

interface Props {
	oldValue: string;
	newValue: string;
	compareMethod?: DiffMethod;
}

const ConflictDiffView: FC<Props> = (props) => {
	const { oldValue, newValue, compareMethod = DiffMethod.WORDS } = props;

	const getValue = (value) => {
		return typeof value !== 'string' ? JSON.stringify(value) : value;
	};

	return (
		<ReactDiffViewer
			oldValue={getValue(oldValue)}
			newValue={getValue(newValue)}
			styles={{
				line: { wordBreak: 'break-word' },
				variables: {
					light: { codeFoldGutterBackground: '#f7f7f7', codeFoldBackground: '#fafbfc' }
				}
			}}
			extraLinesSurroundingDiff={1}
			showDiffOnly={true}
			compareMethod={compareMethod}
			splitView={false}
		/>
	);
};

export default ConflictDiffView;
